"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const up = async (knex)=>{
    await knex.schema.createTable('nc_shared_bases', (table)=>{
        table.increments();
        table.string('project_id');
        table.string('db_alias');
        table.string('roles').defaultTo('viewer');
        table.string('shared_base_id');
        table.boolean('enabled').defaultTo(true);
        table.string('password');
        table.timestamps(true, true);
    });
};
const down = async (knex)=>{
    await knex.schema.dropTable('nc_shared_bases');
};
